intra_module.directive('likes', function() {
	return {
		restrict:    'E',
		templateUrl: 'directives/conversations/likes/template.html',
		controller:  'LikeCtrl',
		replace:     true,

		scope: {
			message:         '=',
			conversation_id: '=conversationId'
		}
	};
});
